import Footer from "../Footer";
import Header from "../Header";

const Causes = () => {
    return (
    <>
    <Header/>
    <div className="topHeading">
    <h2>Causes</h2>
    </div>
    <Footer/>
    </>
    )
}
export default Causes;
